import React from 'react';

const AWS_Fargate = () => {
  return (
    <div>
      <h1>AWS_Fargate</h1>
      <p>This is the AWS_Fargate component.</p>
    </div>
  );
};

export default AWS_Fargate;
